import React, { ReactNode } from 'react';
import { useUser } from '../contexts/UserContext';
import { isLscAdminOnly } from '../config/featureFlags';
import LscComingSoonPage from '../lsc/pages/LscComingSoonPage';

interface LscRouteGuardProps {
  children: ReactNode;
}

/**
 * UX gate for LSC routes while LSC_ADMIN_ONLY is on.
 * Non-admin / logged-out → COMING SOON.
 * Admin (rtts_admin) → full LSC.
 * A member who claimed a signed invite → their league, still not admin.
 * Backend LSC_ADMIN_ONLY is the enforcement boundary.
 */
const LscRouteGuard: React.FC<LscRouteGuardProps> = ({ children }) => {
  const { user, loading } = useUser();

  if (!isLscAdminOnly()) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div
        className="min-h-screen bg-secondary-900"
        data-testid="lsc-admin-gate-loading"
      />
    );
  }

  if (user?.rtts_admin === true || user?.lsc_member_access === true) {
    return <>{children}</>;
  }

  return <LscComingSoonPage />;
};

export default LscRouteGuard;
